<template>
  <v-dialog
    v-model="showDialog"
    width="500"
    persistent
  >
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ caseActionCaption }}
      </v-card-title>
      <v-card-text style="white-space: pre-wrap;">
        <v-text-field
          :rules="[v => (v || '' ).length <= 40]"
          v-model="caseText" label="Kurze Anweisung zur Aufgabe (max. 40 Zeichen)"></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="acceptedDialog"
        >
          Ok
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="closeDialog"
        >
          Abbrechen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'TodoDialog',

  methods: {
    closeDialog () {
      this.$emit('onCancelText')
      this.showDialog = false
    },

    acceptedDialog () {
      this.$emit('onAcceptedText', this.caseText)
      this.showDialog = false
    }
  },

  watch: {
    propShowDialog (val) {
      this.showDialog = val
    },
    propCaseAction (val) {
      this.caseAction = val
    },
    propCaseActionCaption (val) {
      this.caseActionCaption = val
    }
  },

  props: {
    propShowDialog: { type: Boolean },
    propCaseActionCaption: { type: String }
  },

  data () {
    return {
      showDialog: this.propShowDialog,
      caseActionCaption: this.propCaseActionCaption,
      caption: '',
      caseText: ''
    }
  }
}
</script>
